import { render, staticRenderFns } from "./ArticleCard.vue?vue&type=template&id=b25445ae&scoped=true&"
import script from "./ArticleCard.vue?vue&type=script&lang=ts&"
export * from "./ArticleCard.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleCard.vue?vue&type=style&index=0&id=b25445ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25445ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VSpacer})
